<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Manage Subject & Grade</h3>
        <br /><br />
        <br /><br />
      </div>
    </div>

    <CCard
      style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px"
      class="custom-card h-100 full-height"
    >
      <CRow>
        <CCol
          style="height: 100vh"
          sm="12"
          class="justify-content-center m-0 h-100"
        >
          <CContainer style="height: 100vh" class="h-100">
            <CCol sm="12" lg="12" class="custom-margin h-100">
              <CRow>
                <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
                  Manage Subject And Grade <br />
                </h5>
                <CCard style="width: 100%; height: 100%" class="p-3">
                  <h5 class="ml-3 mb-3">Add New Subject for Teacher</h5>
                  <CCol sm="12">
                    <CRow>
                      <CCol class="justify-content-center" sm="4" lg="4">
                        <div>
                          <label>Teacher</label>
                          <v-select
                            v-model="SelectedTeacher"
                            :options="list"
                            label="Name"
                            placeholder="--Please Select--"
                          ></v-select>
                        </div>
                      </CCol>
                      <br />
                      <CCol class="justify-content-center" sm="4" lg="4">
                        <div>
                          <label>Subject</label>
                          <v-select
                            v-model="SelectedSubject"
                            :options="subjects"
                            label="SubjectName"
                            placeholder="--Please Select Subject--"
                            required
                          ></v-select>
                        </div>
                      </CCol>
                      <CCol class="justify-content-center" sm="4" lg="4">
                        <div>
                          <label>Grade</label>
                          <v-select
                            v-model="SelectedGrade"
                            :options="grades"
                            label="GradeName"
                            placeholder="--Please Select Grade--"
                            required
                          ></v-select>
                        </div>
                      </CCol>
                      <br />
                      <CCol class="justify-content-center mt-4" sm="12" lg="12">
                        <CButton
                          style="background: #1565d8"
                          block
                          color="primary"
                          @click="NewSubject"
                          >Save</CButton
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CCard>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

    <CModal title="Success" size="sm" color="success" :show.sync="successModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <h3 class="text-center">SUCCESS !</h3>
      <CCol sm="12">
        <label class="text-center m-0">You have successfully save subject and grade for teacher.</label>
      </CCol>
    </CModal>

     <CModal title="Error" size="sm" color="danger" :show.sync="errorModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
           <img class="m-0" width="100px" src="../assets/img/iconerror.png" />
        </div>
      </CCol>

      <h3 class="text-center">ERROR !</h3>
      <CCol sm="12">
        <label class="text-center m-0">Data Already Exist</label>
      </CCol>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
Vue.use(VuejsDialog);
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      confirm: [],
      languages: [],
      sessions: [],
      times: [],
      subjects: [],
      list: [],
      grades: [],
      acc: {},
      successModal: false,
      declineModal: false,
      Busy: false,
      status: false,
      SelectedSubject: "",
      SelectedTeacher: "",
      SelectedGrade: "",
      errorModal: false,
    };
  },
  async mounted() {
    await this.GetListOfTeacher();
    await this.GetListOfSubject();
     await this.GetGrade();
  },
  methods: {
    async GetListOfTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
            this.getPic(this.FilterList.PicturePath);
          }
        });
    },
    async GetListOfSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
     async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },

    NewSubject() {
      const formData = new FormData();

      formData.append("TeacherId", this.SelectedTeacher.TeacherId);
      formData.append("Content", this.SelectedSubject.SubjectName);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("ContentGrade", this.SelectedGrade.GradeName);

      return this.$API
        .post(this.$TeacherTeachSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null && response.data > 0) {
             this.successModal = true;
          }
          else{
                this.errorModal = true;

          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
